import React, { useEffect, useState } from "react";
import { HI } from "./hi";
import { serverHindi } from "./hiServer";

/**
 * Karkhana screens in English or Hindi, chosen on the phone and remembered there. Independent of
 * the app-wide language. Keys are the English text, so anything not yet translated stays English.
 */
export type KLang = "en" | "hi";

const KEY = "hkp.karkhana.lang";
const EVENT = "hkp-karkhana-lang";

export const readLang = (): KLang => {
  try {
    return localStorage.getItem(KEY) === "hi" ? "hi" : "en";
  } catch {
    return "en";
  }
};

export const setLang = (lang: KLang) => {
  try {
    localStorage.setItem(KEY, lang);
  } catch {
    // Storage blocked: the choice lasts until the page reloads.
  }
  window.dispatchEvent(new CustomEvent(EVENT, { detail: lang }));
};

/** Translate English text; {{name}} placeholders are filled from vars. */
export const translate = (lang: KLang, text: string, vars?: Record<string, string | number | undefined | null>): string => {
  const base = lang === "hi" ? HI[text] ?? serverHindi(text) ?? text : text;
  if (!vars) return base;
  return base.replace(/\{\{(\w+)\}\}/g, (_, k) => (vars[k] === undefined || vars[k] === null ? "" : String(vars[k])));
};

export type T = (text: string, vars?: Record<string, string | number | undefined | null>) => string;

export const useKT = (): { t: T; lang: KLang } => {
  const [lang, set] = useState<KLang>(readLang);
  useEffect(() => {
    const on = (e: Event) => set(((e as CustomEvent).detail as KLang) || readLang());
    window.addEventListener(EVENT, on);
    return () => window.removeEventListener(EVENT, on);
  }, []);
  return { t: (text, vars) => translate(lang, text, vars), lang };
};

/** EN | हिंदी switch for the supervisor screens. */
export const LangToggle = () => {
  const { lang } = useKT();
  return (
    <div className="kr-lang" role="group" aria-label="Language / भाषा">
      <button type="button" className={`kr-choice${lang === "en" ? " is-on" : ""}`} onClick={() => setLang("en")}>
        EN
      </button>
      <button type="button" className={`kr-choice${lang === "hi" ? " is-on" : ""}`} onClick={() => setLang("hi")}>
        हिंदी
      </button>
    </div>
  );
};
